import { useRef } from 'react'
import { Button } from 'react-bootstrap'
import { TfiImport } from 'react-icons/tfi'
import server from '../../server'
import { toast } from 'react-toastify'

const ImportCustomerSales = ( { onSuccess, customer_id = undefined } ) => {
    const fileInput = useRef( null )

    const triggerInputFile = () => fileInput.current.click()

    const handleFileChange = ( e ) => {
        const formData = new FormData()

        if ( customer_id ) {
            formData.append( 'file', e.target.files[ 0 ] )
        } else {
            if ( e.target.files.length ) {
                [ ...e.target.files ].forEach( file => {
                    formData.append( 'files[]', file )
                } )
            }

        }

        server.useApi( {
            url: customer_id ? `/api/v1/customers/${ customer_id }/sales/import/` : `/api/v1/customers/sales-history/import/`,
            method: "post",
            data: formData,
        } )
            .then( ( response ) => {
                toast.success( response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                } )

                onSuccess( 1 )

            } ).catch( ( error ) => {
                const message = error?.response?.data?.message

                if ( message ) {
                    toast.error( message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    } )
                }
            } )

        e.target.value = null
    }

    return (
        <>
            <div className='float-end mb-3'>
                <input style={ { display: 'none' } } ref={ fileInput } type='file' onChange={ ( e ) => handleFileChange( e ) }
                    accept='application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' { ...( customer_id ? '' : { multiple: true } ) } />
                <Button className='d-flex align-items-center' onClick={ triggerInputFile } ><TfiImport className='me-2' />Import Sales History </Button>
            </div>
        </>
    )
}

export default ImportCustomerSales